<template>
  <v-row class="mt-10" v-if="show">
    <v-col cols="6">
      <v-btn
        block
        elevation="0"
        color="#FF383C33"
        class="text-none"
        height="44"
        variant="flat"
        style="border: 1px solid #E8392E;"
        @click="$emit('decline')"
      >
        <span style="color: #E8392E;">{{ $t("Default.reject") }}</span>
      </v-btn>
    </v-col>

    <v-col cols="6">
      <v-btn
        block
        elevation="0"
        color="#27AE6033"
        class="text-none"
        height="44"
        variant="flat"
        style="border: 1px solid #27AE60;"
        @click="$emit('accept')"
      >
        <span style="color: #27AE60;">{{ $t("Default.accept") }}</span>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AdminAcceptDeclineButtons',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
